import { gql } from '@apollo/client';

export const GET_MY_ACHIEVEMENTS = gql`
  query GetMyAchievements($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        awardedAchievements {
          awardedAchievementId
          awardedAt
          seenAt
          level {
            achievementLevelId
            name
            position
            badgeDesign
            achievement {
              achievementId
              name
            }
          }
        }
        certificates {
          volunteerCertificateId
          templateName
          awardedFor
          issuedAt
          seenAt
        }
        achievementProgress {
          achievementId
          value
        }
      }
      achievements {
        achievementId
        name
        metric
        isEnabled
        showProgress
        levels {
          achievementLevelId
          name
          position
          threshold
          badgeDesign
        }
      }
    }
  }
`;
